import { type ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { EmploymentType } from '@/services/graphql/generated'
import { Select } from 'ui/src/components/Select/Select'

export function EmploymentTypeSelect(props: ComponentProps<typeof Select.Root>) {
  const { t } = useTranslation('purchase-form')

  const EMPLOYMENT_TYPE_OPTIONS = [
    { name: t('EMPLOYMENT_TYPE_OPTION_PERMANENT_EMPLOYED_FULLTIME'), value: EmploymentType.PermanentEmployedFulltime },
    { name: t('EMPLOYMENT_TYPE_OPTION_PERMANENT_EMPLOYED_PARTTIME'), value: EmploymentType.PermanentEmployedParttime },
    { name: t('EMPLOYMENT_TYPE_OPTION_CONTRACT_EMPLOYED'), value: EmploymentType.ContractEmployed },
    { name: t('EMPLOYMENT_TYPE_OPTION_SELF_EMPLOYED'), value: EmploymentType.SelfEmployed },
    { name: t('EMPLOYMENT_TYPE_OPTION_UNEMPLOYED'), value: EmploymentType.Unemployed },
  ] as const

  return (
    <Select.Root size="medium" {...props}>
      <Select.Trigger fullWidth={true}>
        <Select.Label>{t('EMPLOYMENT_TYPE_LABEL')}</Select.Label>
        <Select.Value />
      </Select.Trigger>
      <Select.Content>
        <Select.Options>
          {EMPLOYMENT_TYPE_OPTIONS.map((option) => (
            <Select.Item key={option.value} value={option.value}>
              <Select.ItemText>{option.name}</Select.ItemText>
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Options>
      </Select.Content>
    </Select.Root>
  )
}
